// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kAS8","colBig":"styles_colBig__hgjtR","colSmall":"styles_colSmall__PH87R","shopifyNameWrapper":"styles_shopifyNameWrapper__DTeNc"};